import { Component, Inject, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';

@Component({
  selector: 'app-product-group-detail-model',
  templateUrl: './product-group-detail-model.component.html'
})

export class ProductGroupDetailModelComponent implements OnInit {
  gallery:any=[];
  // @Inject(MAT_DIALOG_DATA) public data: any

  constructor(@Inject(MAT_DIALOG_DATA) public data:any) {
    // setTimeout(() => {
      
    //   console.log(this.data);
    // }, 2000);
    
   }


  ngOnInit() {
    this.gallery = new Array(4);
  }

}
// function Inject(MD_DIALOG_DATA: any) {
//   throw new Error('Function not implemented.');
// }

// function MD_DIALOG_DATA(MD_DIALOG_DATA: any) {
//   throw new Error('Function not implemented.');
// }

